import {ACTIONS, CONFIG, I18N} from '../../globals/config';
import {post} from './Request';
import {TestResult} from '../../components/TestResults';
import {getState, setState} from '../../globals/state';


const errorResult: TestResult = {
	testId: 'error',
	result: false,
	label: I18N.something_wrong,
	message: I18N.could_not_run,
	fixAvailable: false,
};

type fixResponse = {
	fixedNewUrl: string;
	fixedTestResults: TestResult
}

export async function getTestResults(): Promise<TestResult[]> {
	try {
		return await post<TestResult[]>( ACTIONS.getResults, {
			[ CONFIG.fields.tests.new ]: getState( 'newUrl' ),
			[ CONFIG.fields.tests.old ]: getState( 'oldUrl' ),
		} );
	} catch ( e ) {
		return [ errorResult ];
	}
}

export async function getFix( testId: string ): Promise<TestResult> {
	try {
		const result = await post<fixResponse>( ACTIONS.getFixedUrl, {
			[ CONFIG.fields.tests.new ]: getState( 'newUrl' ),
			[ CONFIG.fields.tests.old ]: getState( 'oldUrl' ),
			[ CONFIG.fields.tests.testId ]: testId,
		} );
		setState( {
			newUrl: result.fixedNewUrl,
		} );
		return result.fixedTestResults;
	} catch ( e ) {
		return errorResult;
	}
}
